import { onAddressChangedEvent } from '../../Shared/React/js/components/addressSearch/AddressSearch';

(function () {
    'use strict';
    var promise = null;

    function main() {
        var controller = {
            init: function () {
                var widgets = wo$('[data-widget-type="broadband-search-form"]');
                if (!widgets.length) return;

                var selectValuesFromQuery = function (widget) {
                    var query = decodeURIComponent(wo$(widget).data('query'));

                    var address = WhistleOut.getQueryStringParameter('address', query);
                    if (address) {
                        wo$(widget).find('input[data-address-input]').val(address);
                    }

                    var data = WhistleOut.getQueryStringParameter('data', query);
                    if (data) {
                        wo$(widget)
                            .find('select[data-data-select] option[value="' + data + '"]')
                            .prop('selected', true);
                    }

                    var speed = WhistleOut.getQueryStringParameter('speed', query);
                    if (speed) {
                        wo$(widget)
                            .find('select[data-speed-select] option[value="' + speed + '"]')
                            .prop('selected', true);
                    }
                };

                for (var index = 0; index < widgets.length; index++) {
                    selectValuesFromQuery(widgets[index]);
                }

                widgets.off('click');
                widgets.on('click', '[data-search-button]', function () {
                    controller.search(wo$(this));
                });

                addEventListener(onAddressChangedEvent, function () {
                    var widget = wo$(this).find('[data-widget-type="broadband-search-form"]');
                    if (
                        widget.data('auto-fill-address') === 'True' &&
                        widget.data('mode') === 'Express' &&
                        widget.find('[data-address-input]').val() !== ''
                    ) {
                        controller.search(wo$(this).find('[data-search-button]'));
                    }
                });
            },

            checkCoverage: function (url, address, widget) {
                promise = new Promise(function (resolve) {
                    var useDefaultSuppliers = false;
                    var transactUrl = '';
                    var supplierName = '';
                    var supplierImageUrl = '';
                    if (address) {
                        url = WhistleOut.updateQueryStringParameter(url, 'address', address);
                        wo$.ajax({
                            url: url,
                            type: 'GET',
                            success: function (result) {
                                if (result) {
                                    WhistleOut.setCoverageCookie(result.coverage);
                                    useDefaultSuppliers = result.useDefaultSuppliers;
                                    if (widget.data('mode') === 'Express') {
                                        transactUrl = result.transactUrl;
                                        supplierName = result.supplierName;
                                        supplierImageUrl = result.supplierImageUrl;
                                    }
                                }
                                return resolve({
                                    useDefaultSuppliers: useDefaultSuppliers,
                                    transactUrl: transactUrl,
                                    supplierName: supplierName,
                                    supplierImageUrl: supplierImageUrl
                                });
                            }
                        });
                    } else {
                        return resolve({
                            useDefaultSuppliers: false,
                            transactUrl: '',
                            supplierName: '',
                            supplierImageUrl: ''
                        });
                    }
                });
            },

            search: function ($this) {
                $this.find('.fa-spinner').show();

                WhistleOut.trackEvent('BroadbandSearchForm', 'Search');

                var widget = $this.parents('[data-widget-type="broadband-search-form"]');
                var coverageUrl = widget.data('coverageurl');
                var address = widget.find('[data-address-input]').val();
                controller.checkCoverage(coverageUrl, address, widget);

                var searchUrl = widget.data('searchurl');
                var defaultSuppliers = widget.data('defaultsuppliers');
                var detectLocation = widget.data('detectlocation');
                var initialQueryParams = widget.data('query');
                var maxResultsPerSupplier = widget.data('maxresultspersupplier');
                var monetised = widget.data('monetised');
                var data = widget.find('[data-data-select]').val();
                var speed = widget.find('[data-speed-select]').val();

                var queryString = '';

                if (initialQueryParams) {
                    queryString = decodeURIComponent(initialQueryParams);
                    if (queryString.indexOf('?') === -1) queryString = '?' + queryString;
                }

                queryString = WhistleOut.updateQueryStringParameter(
                    queryString,
                    'maxresultspersupplier',
                    maxResultsPerSupplier
                );
                queryString = WhistleOut.updateQueryStringParameter(queryString, 'monetised', monetised);

                var dataValue = data || data === 0 ? data : null;
                queryString = WhistleOut.updateQueryStringParameter(queryString, 'data', dataValue);

                var speedValue = speed && speed !== '0' ? speed : null;
                queryString = WhistleOut.updateQueryStringParameter(queryString, 'speed', speedValue);

                queryString = WhistleOut.updateQueryStringParameter(
                    queryString,
                    'tab',
                    WhistleOut.getSiteConfiguration().broadbandConfig.defaultTab
                );

                if (address && address.length) {
                    queryString = WhistleOut.updateQueryStringParameter(
                        queryString,
                        'address',
                        address.replace(/\s+/g, '+')
                    );
                    controller.executeSearch(widget, searchUrl, queryString, defaultSuppliers);
                } else if (detectLocation === true || detectLocation === 'True') {
                    WhistleOut.getCurrentLocation(
                        function (e) {
                            var address = e.label;
                            if (address && address.length > 1) {
                                queryString = WhistleOut.updateQueryStringParameter(
                                    queryString,
                                    'address',
                                    address.replace(/\s+/g, '+')
                                );
                            }
                            controller.executeSearch(widget, searchUrl, queryString, defaultSuppliers);
                        },
                        function () {
                            controller.executeSearch(widget, searchUrl, queryString, defaultSuppliers);
                        }
                    );
                } else {
                    controller.executeSearch(widget, searchUrl, queryString, defaultSuppliers);
                }
            },

            executeSearch: function (widget, url, queryString, defaultSuppliers) {
                if (promise) {
                    promise
                        .then(function (result) {
                            if (result.transactUrl) {
                                widget.find('[data-supplier-name]').html(result.supplierName);
                                widget.find('[data-supplier-image]').attr('src', result.supplierImageUrl);
                                widget.find('[data-heading], [data-form]').hide();
                                widget.find('[data-transact-heading], [data-transact-status]').show();
                                setTimeout(function () {
                                    controller.openSearchWindow(result.transactUrl);
                                }, 3000);
                            } else {
                                if (result.useDefaultSuppliers && defaultSuppliers && defaultSuppliers.length) {
                                    queryString = WhistleOut.updateQueryStringParameter(
                                        queryString,
                                        'supplier',
                                        defaultSuppliers
                                    );
                                }
                                controller.openSearchWindow(url + queryString);
                            }
                        })
                        .catch(function () {
                            controller.openSearchWindow(url + queryString);
                        });
                } else {
                    controller.openSearchWindow(url + queryString);
                }
            },

            openSearchWindow: function (url) {
                var win = window.open(url, '_top');
                win.focus();
            }
        };

        WhistleOut.initWidget = controller.init;
        controller.init();
    }

    WhistleOut.initModule(import.meta.url, main);
})();
